import { render } from "./tw-ws-pie.vue?vue&type=template&id=979614be"
import script from "./tw-ws-pie.vue?vue&type=script&lang=js"
export * from "./tw-ws-pie.vue?vue&type=script&lang=js"
script.render = render

export default script